import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { ApolloProvider } from '@apollo/client';
import { AuthProvider } from 'src/contexts/auth';
import createApolloClient from 'src/utils/apollo';
import Layout from 'src/layout';
import 'src/assets/mapbox-gl.css';
import 'src/bootstrap/extra/icons.font';
import { ToastProvider } from 'src/contexts/toast';
import MuiRTL from 'src/theme/mui/rtl';
import MuiTheme from 'src/theme/mui/theme';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import i18nBase from 'src/i18n';

function App({ router = null, routerProps = {} as any, apolloClient = null, i18nInstance = null }) {
	const Router = router ?? BrowserRouter;
	const client = apolloClient ?? createApolloClient();
	const i18n = i18nInstance ?? i18nBase;

	return (
		<ApolloProvider client={client}>
			<I18nextProvider i18n={i18n}>
				<LocalizationProvider dateAdapter={AdapterDayjs}>
					<Router {...routerProps}>
						<MuiRTL>
							<MuiTheme>
								<ToastProvider>
									<AuthProvider>
										<Layout />
									</AuthProvider>
								</ToastProvider>
							</MuiTheme>
						</MuiRTL>
					</Router>
				</LocalizationProvider>
			</I18nextProvider>
		</ApolloProvider>
	);
}

export default App;
